var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.tipoEmpresaSelecionada == 'Proponente')?_c('dashboard-proponente'):_vm._e(),(this.tipoEmpresaSelecionada == 'Executora')?_c('dashboard-executora'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }